import { Link } from "react-router";

export function NotFound() {
  return (
    <section className="at-page">
      <p className="at-eyebrow">Astranote</p>
      <h1>Not found</h1>
      <div className="at-card"><p>Nothing lives at this address. <Link to="/">Back home</Link>, or pick a page from the navigation.</p></div>
    </section>
  );
}
